import { ReactElement } from 'react';
import warningSvg from 'assets/icons/warning.svg';
import Button, { Color, TextOverflow } from 'lib/Button';
import Modal from 'lib/Modal';

interface UnsavedCampaignChangesModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  onDiscard: () => void;
  onSave: () => void;
  isSaveDisabled?: boolean;
}

export const UnsavedCampaignChangesModal = ({
  isOpen,
  onDismiss,
  onDiscard,
  onSave,
  isSaveDisabled,
}: UnsavedCampaignChangesModalProps): ReactElement => {
  return (
    <Modal
      dataTestId="unsaved-campaign-changes-modal"
      isOpen={isOpen}
      onClose={onDismiss}
      icon={warningSvg}
      title="Unsaved changes"
      actionButtons={
        <>
          <Button
            onClick={onDiscard}
            label="Discard"
            color={Color.DANGER}
            textOverflow={TextOverflow.VISIBLE}
            dataTestId="unsaved-campaign-changes-discard"
          />
          <Button
            onClick={onSave}
            label="Save"
            color={Color.PRIMARY}
            textOverflow={TextOverflow.VISIBLE}
            isDisabled={isSaveDisabled}
            dataTestId="unsaved-campaign-changes-save"
          />
        </>
      }
    >
      <div className="body-base text-neutral-950-opacity-60">
        You have made unsaved changes to Campaign Information, exiting without saving will discard these changes, would
        you like to Save or Discard?
      </div>
    </Modal>
  );
};
